export enum CallDirection {
  Inbound = 1,
  Outbound = 2,
  Internal = 3,
}
